import GLException from '../GLException';

const GlExceptionScreen = () => {
  return <GLException reportType="GLException" />;
};

export default GlExceptionScreen;
